import React from 'react'
import { Badge } from 'react-bootstrap'
import './statusPill.css'
import { InvoiceState } from '../../utilities/invoice'

interface StatusPillProps {
	status: InvoiceState
}

const StatusPill = (props: StatusPillProps) => {
	return (
		<Badge bg={props.status} pill>
			{props.status}
		</Badge>
	)
}

export default StatusPill
